<main class="Main">
	<section class="Main-whiteBackground">
		<div class="Section-container">
			<div class="Subsections">
				<div class="Subsection">
					<h2 class="H2">Custom Applications</h2>
					<p>I've helped organizations from Ancestry to WGU to small and medium local companies with custom applications in varying languages and frameworks. You can have me help you with your software or help you figure out what you need to get it working.</p>
				</div>
				<div class="Subsection">
					<h2 class="H2">Content Management Systems</h2>
					<p>Content Management Systems (CMS) have become a great way to publish your digital content. I've built multiple WordPress sites with provided and custom themes, as well as a few custom plugins.</p>
				</div>
			</div>
		</div>
	</section>

	<section class="Main-blackBackground">
		<div class="Section-container">
			<div class="Subsections">
				<div class="Subsection Subsection-singleImage">
					<img class="Profile" src="/images/jasontoon.png" alt="Jason Anderson">
				</div>
				<div class="Subsection">
					<div>
						<h2 class="H2">Jason Anderson</h2>
						Owner &amp; Operator<br />
						<i class="fa-solid fa-phone Icon"></i> 801-899-7890
						<p class="First-paragraph">Call or text me with your questions.</p>
					</div>
					<p class="First-paragraph">Since 2007 I've been developing production software for companies large and small. I focus on best practices that will give you great solutions that are easily maintained.</p>
					<p>Let's chat about your project.</p>
				</div>
			</div>
		</div>
	</section>
</main>

<style>
	.Main-blackBackground {
		background-color: #000;
		color: #fff;
		line-height: 1.5em;
	}
	.Icon {
		font-size: .75em;
		margin-right: .5em;
	}
	.H2 {
		font-size: 40px;
		font-weight: normal;
		margin-bottom: .5em;
	}
	.Section-container {
		margin: 0 auto;
	}
	.Subsections {
		display: grid;
		gap: 10px;
		grid-template-rows: auto auto;
		margin: 50px 50px 0;
	}
	.Subsection {
		padding: 50px 0;
	}
	.Subsection-singleImage {
		align-items: center;
		display: flex;
		justify-content: center;
		padding: 25px;
	}
	.Profile {
		border-radius: 50%;
		width: 100%;
	}
	p {
		margin-bottom: 1em;
	}
	.First-paragraph {
		margin-top: 1em;
	}
	@media only screen and (min-width: 768px) {
		.Subsections {
			gap: 50px;
			grid-template-columns: 1fr 1fr;
		}
		.Subsection {
			padding: 0;
		}
		.Section-container {
			overflow: hidden;
		}
		.Profile {
			height: 250px;
			width: auto;
		}
	}
	@media only screen and (min-width: 1200px) {
		.Section-container {
			max-width: 1200px;
		}
		.Profile {
			height: 300px;
		}
	}
</style>